// import message from 'kts-scaffold-framework/component/Message';
import { ICallResponse, IServiceAgentRequest } from 'grey-service-agent';
import { SuperAgentRequest } from 'superagent';
import { history } from '../routes';
import { MyStore, reducers } from '../redux';
import WarningContent from '../appSdk/AppResource/WarningContent';
import { Modal, message } from 'kts-xui';
import language from '../language';
import React from 'react';

const css = require('./index.scss');

/** 请求列表 */
const requestList: any[] = [];

/** 错误消息 */
const messageErrorList: any[] = [];

/** url 转 uri */
export function urlToUri(url: string): string {
    const arr = url.replace(/\/\/|http:\/\/|https:\/\//, '').split('/'); arr.shift();
    const uri = `/${arr.join('/')}`;
    return uri.split('?')[0];
}

/** 是否异常 */
export function isSuccess(e: ICallResponse) {
    return e.err ? null : e.res;
}

/** 添加加载接口 */
export function addLoading(req: IServiceAgentRequest): IServiceAgentRequest {

    MyStore.instance.dispatch(reducers.system.ActionTypes.addLoading, urlToUri(req.sar.url));
    return req;
}

/** 删除加载接口 */
export function removeLoading(e: ICallResponse): ICallResponse {

    let sar: SuperAgentRequest = e.sar;
    MyStore.instance.dispatch(reducers.system.ActionTypes.removeLoading, urlToUri(sar.url));
    return e;
}

/** 重复请求开始 */
export function repeatCallStart(req: IServiceAgentRequest): IServiceAgentRequest {

    for (let i = 0; i < requestList.length; i++) {
        let selfReq = requestList[i] as IServiceAgentRequest;
        const url = selfReq.sar.url.split('?')[0];
        if (selfReq.target === req.target && url === req.sar.url) {
            console.error('重复请求:', req.sar.url);
            req.err = '重复请求';
            return req;
        }
    }

    if (req.target) {
        requestList.push(req);
    }

    return req;
}

/** 重复请求结局 */
export function repeatCallEnd(e: ICallResponse): ICallResponse {

    if (e.err === '重复请求') {
        return e;
    }

    for (let i = 0; i < requestList.length; i++) {
        const selfReq = requestList[i] as IServiceAgentRequest;
        if (selfReq.target === e.target && selfReq.sar.url === e.sar.url) {
            requestList.splice(i, 1);
        }
    }
    return e;
}

/** 验证是否有Token */
export function isHaveToken(req: IServiceAgentRequest): IServiceAgentRequest {
    const { user } = MyStore.instance.getState();
    if (!user.cToken) {
        console.error('用户未登录');
        req.err = '用户未登录';
    }
    return req;
}

/** 添加头信息 Content-Type */
export function addContentType(req: IServiceAgentRequest): IServiceAgentRequest {
    req.sar.set({ 'Content-Type': 'application/json' });
    return req;
}

/** 添加头信息 Authorization */
export function addAuthorization(req: IServiceAgentRequest): IServiceAgentRequest {
    const { user } = MyStore.instance.getState();
    try {
        if (user.cToken && !req.sar['header']['Authorization']) {
            req.sar.set({ Authorization: user.cToken });
        }
    } catch (error) {
        req.sar.set({ Authorization: user.cToken });
    }
    return req;
}

/** 添加头信息 x-kxl-app-key */
export function addAppKey(req: IServiceAgentRequest): IServiceAgentRequest {

    let key: string | null = null;
    const pathname = window.location.pathname;
    const appMap = MyStore.instance.getState().config.appList.map;

    appMap.forEach((e, k) => {
        if (pathname.indexOf(e.URL) === 0) {
            key = k;
        }
    });

    if (key === null) {
        const arr = pathname.split('/workbench/m/');
        if (arr.length > 1) {
            key = (arr.pop() || '').split('/')[0];
        }
    }

    if (key && req.sar['header']['x-kxl-app-key'] === undefined) {
        req.sar.set({ 'x-kxl-app-key': key });
    }

    return req;
}

/** 添加头信息 x-kxl-language */
export function addLanguage(req: IServiceAgentRequest): IServiceAgentRequest {
    req.sar.set({ 'x-kxl-language': language.state });
    return req;
}

/** 验证服务器数据是否错误 */
export function verificationResponse(res: ICallResponse): ICallResponse {

    /** 发送消息 */
    const messageError = (text: string) => {
        // 消息是否存在
        if (messageErrorList.indexOf(text) === 0) {
            return;
        }

        // 发送消息
        messageErrorList.unshift(text);
        message.error(text);

        // 一秒后删除记录
        setTimeout(() => {
            messageErrorList.splice(messageErrorList.indexOf(text), 1);
        }, 2000);
    };

    try {
        if (
            res.err &&
            res.err.status === 403 &&
            res.err.response &&
            res.err.response.body &&
            res.err.response.body.body === '接口未授权'
        ) {
            return res;
        }
    } catch (error) {
        console.error(error);
    }

    // 通信错误
    try {
        if (typeof res.err === 'string') {
            return res;
        }



        if (res.err) {
            if (res.err.response && res.err.response.body && res.err.response.body.message) {
                messageError(res.err.response.body.message);
            } else {
                messageError('网络异常,请重试');
            }
            return res;
        }

        // 通行错误
        if (res.res.ok === false) {
            messageError('网络异常,请重试');
            return res;
        }

        // 业务失败
        if (res.res.body && res.res.body.ok === false) {
            if (res.res.body.status && res.res.body.status.description) {
                messageError(res.res.body.status.description);
            } else if (res.res.body.status && res.res.body.status.message) {
                messageError(res.res.body.status.message);
            }
            else {
                messageError('服务异常');
            }
            return res;
        }
    } catch (er) {
        messageError('网络异常,请重试');
        return res;
    }

    return res;
}

/** 未权限处理 */
export function purview(e: ICallResponse): ICallResponse {
    try {
        if (e.err.status === 403 && e.err.response.body.body === '接口未授权') {
            Modal.warning({
                icon: null,
                className: css.modalWarning,
                content: <WarningContent />
            });
        }
    } catch (error) {

    }
    return e;
}

/** 登录失效处理 */
export function loginInvalid(e: ICallResponse): ICallResponse {
    try {
        if (e.res.body.status.returnCode === '02001') {
            MyStore.instance.dispatch(reducers.user.ActionTypes.fnSetUserInfo, { gToken: null, cToken: null });
            if (window.location.pathname !== '/login') {
                MyStore.instance.dispatch(reducers.user.ActionTypes.fnSetUserInfo, { gToken: null, cToken: null });
                if (window.location.href) {
                    history.push(`/login?redirectURL=${escape(window.location.pathname + window.location.search)}`);
                } else {
                    history.push(`/login`);
                }
            }
        }
    } catch (error) {
    }
    return e;
}

/** 提取业务数据 */
export function extractData(e: ICallResponse): ICallResponse {

    const target = e.target;
    const err = e.err;
    const res = e.res;
    const sar = e.sar;

    // 通信错误
    try {
        if (e.err) {
            return e;
        }

        // 通行错误
        if (e.res.ok === false) {
            return { target, sar, err: res, res: undefined };
        }

        // 业务失败
        if (e.res.body && e.res.body.ok === false) {
            return { target, sar, err: res, res: undefined };
        }
    } catch (er) {
        return { target, sar, err: e, res: undefined };
    }

    return { target, sar, err, res: e.res.body && (e.res.body.body === undefined ? e.res.body : e.res.body.body) };
}



// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/service/Tools.tsx